<span [ngClass]="otherClass" *ngIf="address">
  {{ address.residence }}
  <span *ngIf="address.floor" data-ng-class="{ 'capitalize' : !address.residence }"
    >{{ 'address.floor' | translate }} {{ address.floor }}</span
  >
  <br *ngIf="(address.residence || address.floor) && !showInOneLine" />
  <span *ngIf="showInOneLine && (address.residence || address.floor)">-</span>
  {{ address.street }}<span *ngIf="address.houseNumber">&nbsp;</span>{{ address.houseNumber
  }}<span *ngIf="!address.fictiveAddress && address.houseNumberAlpha"
    >&nbsp;{{ address.houseNumberAlpha }}</span
  >
  <span *ngIf="address.box">&nbsp;{{ 'address.box' | translate }} {{ address.box }}</span>
  <span *ngIf="address.fictiveAddress">&nbsp;{{ 'address.nearby' | translate }}</span>
  <br *ngIf="!showInOneLine" />
  <span *ngIf="showInOneLine && (address.zip || address.city)">, </span>
  {{ address.zip }} {{ address.city }}<br *ngIf="!showInOneLine" />
  <span *ngIf="showCountry && showInOneLine && address.country">, </span>
  <span *ngIf="showCountry">{{ address.country }}</span>
</span>
<span *ngIf="!address">{{ 'address.noAddress' | translate }}</span>
